import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as OrganizationSelectors } from 'data/organizations'

import { dataFetched, makesSubscriptions } from 'data/graphql'

import { organizationAttrsFragment } from 'remote/organizations'

const organizationSubscription = gql`
  subscription organizationUpdated($organizationId: ID!) {
    organizationUpdated(organizationId: $organizationId) {
      ...organizationAttrs
    }
  }
  ${organizationAttrsFragment}
`

const noteResourcesUsageSubscription = gql`
  subscription noteResourcesUsageUpdated {
    noteResourcesUsageUpdated {
      limit
      current
    }
  }
`

const storageResourcesUsageSubscription = gql`
  subscription storageResourcesUsageUpdated {
    storageResourcesUsageUpdated {
      limit
      current
    }
  }
`

const providesOrganizationSubscriptions = compose(
  connect(
    state => ({
      organizationId: OrganizationSelectors.getOrganizationId(state),
    }),
    {
      dataFetched,
    }
  ),
  makesSubscriptions({
    query: organizationSubscription,
    mapPropsToVariables: ({ organizationId }) => ({ organizationId }),
    getOnResultFromProps: ({ dataFetched }) => ({ result, meta }) => {
      const organization = result.data.organizationUpdated
      dataFetched(organization, meta)
    },
  }),
  makesSubscriptions({
    query: noteResourcesUsageSubscription,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched, organizationId }) => ({
      result,
      meta,
    }) => {
      const notes = result.data.noteResourcesUsageUpdated
      // Workaround OrganizationResourcesUsage not being flattened in the store:
      // we wrap this in a dummy OrganizationResourcesUsage object to update it
      const data = {
        __typename: 'OrganizationResourcesUsage',
        id: organizationId,
        notes,
      }
      dataFetched(data, meta)
    },
  }),
  makesSubscriptions({
    query: storageResourcesUsageSubscription,
    mapPropsToVariables: () => ({}),
    getOnResultFromProps: ({ dataFetched, organizationId }) => ({
      result,
      meta,
    }) => {
      const storage = result.data.storageResourcesUsageUpdated
      const data = {
        __typename: 'OrganizationResourcesUsage',
        id: organizationId,
        storage,
      }
      dataFetched(data, meta)
    },
  })
)

export default providesOrganizationSubscriptions
